import { Link } from 'react-router-dom';
import { appRoutes } from '../../app-routes';
import styles from './AiToolsTabs.module.css';

interface AiToolsTabsProps {
  active: 'tools' | 'credentials';
}

const TABS = [
  { id: 'tools', label: 'Tools', to: appRoutes.AI_TOOLS },
  { id: 'credentials', label: 'Credentials', to: appRoutes.AI_CREDENTIALS },
] as const;

/** Top-level navigation between the two Agents sections (tools and their credentials). */
export const AiToolsTabs = ({ active }: AiToolsTabsProps) => (
  <nav className={styles.tabs} aria-label="AI Tools sections">
    {TABS.map(tab => (
      <Link
        key={tab.id}
        to={tab.to}
        aria-current={active === tab.id ? 'page' : undefined}
        className={styles.tab}>
        {tab.label}
      </Link>
    ))}
  </nav>
);
